import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AddAppSlideComponent } from '../add-app-slide/add-app-slide.component';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { IAppSlide } from 'src/app/interfaces/book-store';

@Component({
  selector: 'app-app-slide',
  templateUrl: './app-slide.component.html',
  styleUrls: ['./app-slide.component.scss']
})
export class AppSlideComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.APP_SLIDE;
  DISPLAY_STATUS_KEY: any;
  COLLECTION: any;

  TITLE: any;
  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public store: BookstoreStore,
    private route: ActivatedRoute,
    private storage: FireStorageService
  ) { }

  ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
    this.route.params.subscribe(params => {
      const { id } = params;
      switch (id) {
        case "slides":
          this.tabs = TESTING_CENTER.APP_SLIDE;
          this.TITLE = "Feature";
          this.COLLECTION = COLLECTION_NAME.APP_SLIDES;
          break;
        case "skills":
          this.tabs = TESTING_CENTER.APP_SKILL;
          this.TITLE = "Skill";
          this.COLLECTION = COLLECTION_NAME.APP_SKILL;
          break;
        default:
          this.tabs = TESTING_CENTER.APP_CATEGORY;
          this.TITLE = "Category";
          this.COLLECTION = COLLECTION_NAME.APP_CATEGORY;
          break;
      }
      this.store.fetchData(this.COLLECTION, this.DISPLAY_STATUS_KEY.key)
    })

  }



  create(item?: any) {
    let dialogRef = this.dialog.open(AddAppSlideComponent, {
      data: { ITEM: item || null, COLLECTION: this.COLLECTION, TITLE: this.TITLE },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  delete(item: IAppSlide) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: {
        title: `Delete ${this.TITLE}`,
        memo: `${this.TITLE} will permanently drop from app.`,
        name: item.name,
        button: "OK",
      },
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      disableClose: true,
      role: 'dialog'
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === 'yes') {
        if(item.fileDetail){
          await this.storage.storageRef(item.fileDetail.filename).delete().toPromise();
        }
        this.store.deleteItem(this.COLLECTION, item, (success, error) => {
          if (success) {
            this.snackBar.open(`${this.TITLE} has been deleted.`, 'done', { duration: 2000 });
            this.store.fetchData(this.COLLECTION, this.DISPLAY_STATUS_KEY.key)
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }

}
